import { createSvg } from '@r1-frontend/ui-kit/atoms/svg/createSvg';

const ArrowRight = ({ strokeWidth = 1.5 }: { strokeWidth?: number }): JSX.Element => {
    return (
        <g id={'guts'}>
            <path
                d='M9 6L15 12L9 18'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    );
};

export default createSvg(ArrowRight, 'arrow-right');

